import {
  WHEEL_HASH_DETAIL_FETCH_FAIL,
  WHEEL_HASH_DETAIL_FETCH_RESET,
  WHEEL_HASH_DETAIL_FETCH_START,
  WHEEL_HASH_DETAIL_FETCH_SUCCESS
} from "./constants";
import { WheelHashDetailActions, WheelHashDetailState } from "./types";

const initialState: WheelHashDetailState = {
  loading: false,
  data: undefined,
  error: undefined
}

const reducer = (
  state = initialState,
  action: WheelHashDetailActions,
): WheelHashDetailState => {
  switch (action.type) {
    case WHEEL_HASH_DETAIL_FETCH_START:
      return {
        ...initialState,
        loading: true
      };
    case WHEEL_HASH_DETAIL_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload
      };
    case WHEEL_HASH_DETAIL_FETCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case WHEEL_HASH_DETAIL_FETCH_RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
}

export default reducer;
